import { getListBrowserStore } from '@ts-private/list-browser';

export const documentTypePropertiesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'propertyName',
      caption: 'DocumentTypes.DocumentTypeProperty.PropertyName',
      type: 'text'
    },
    {
      name: 'propertyCode',
      caption: 'DocumentTypes.DocumentTypeProperty.PropertyCode',
      type: 'text'
    },
    {
      name: 'mandatory',
      caption: 'DocumentTypes.DocumentTypeProperty.Mandatory',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'DocumentTypes.DocumentTypeProperty.PropertyName',
      value: 'PropertyName'
    },
    {
      caption: 'DocumentTypes.DocumentTypeProperty.PropertyCode',
      value: 'PropertyCode'
    },
    {
      caption: 'DocumentTypes.DocumentTypeProperty.OrderNo',
      value: 'OrderNo'
    }
  ],
  pager: {
    orderBy: 'PropertyCode',
    direction: 'asc'
  }
});
